import { render, staticRenderFns } from "./Ober.vue?vue&type=template&id=31cd35f3&scoped=true"
import script from "./Ober.vue?vue&type=script&lang=js"
export * from "./Ober.vue?vue&type=script&lang=js"
import style0 from "./Ober.vue?vue&type=style&index=0&id=31cd35f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd35f3",
  null
  
)

export default component.exports